import React, { useState } from 'react';
import { housesAPI, categoriesAPI } from '../services/api';
import './HouseForm.css';

const HouseForm = ({ onClose, onHouseCreated }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const createDefaultCategories = async (houseId) => {
    const defaultCategories = ['Clothes', 'Medicines'];
    for (const catName of defaultCategories) {
      try {
        await categoriesAPI.create({ name: catName, house_id: houseId });
      } catch (error) {
        console.error(`Error creating category ${catName}:`, error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setError('House name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await housesAPI.create(formData);
      const newHouse = response.data;
      
      // Create default categories
      await createDefaultCategories(newHouse.id);
      
      if (onHouseCreated) {
        onHouseCreated(newHouse);
      }
      onClose();
    } catch (error) {
      console.error('Error creating house:', error);
      setError(error.response?.data?.detail || 'Failed to create house');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="house-form-overlay">
      <div className="house-form-modal">
        <div className="house-form-header">
          <h2>Add New House</h2>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="house-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="name">House Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="e.g., Main House, Vacation Home"
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="e.g., 123 Main St, City"
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Creating...' : 'Create House'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HouseForm;


